var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('v-app',[_c('v-container',{attrs:{"fluid":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }